import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Header, GenesysSupportCenter, Footer, Download } from './components';

const MainLayout = () => {
  return (
    <LanguageProvider>
      <Header />
      <GenesysSupportCenter />
      <Footer />
    </LanguageProvider>
  );
};

export const App = () => {
  const isDownloadDomain = typeof window !== 'undefined' && /^(download|app)\./.test(window.location.hostname);

  if (isDownloadDomain) {
    return (
      <Routes>
        <Route path="/" element={<Download defaultLanguage="ar" />} />
        <Route path="/ar" element={<Download defaultLanguage="ar" />} />
        <Route path="/en" element={<Download defaultLanguage="en" />} />
        <Route path="/download" element={<Download defaultLanguage="ar" />} />
        <Route path="/download/ar" element={<Download defaultLanguage="ar" />} />
        <Route path="/download/en" element={<Download defaultLanguage="en" />} />
        <Route path="*" element={<Download defaultLanguage="ar" />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<MainLayout />} />
      <Route path="/ar" element={<MainLayout />} />
      <Route path="/download" element={<Download defaultLanguage="ar" />} />
      <Route path="/download/ar" element={<Download defaultLanguage="ar" />} />
      <Route path="/download/en" element={<Download defaultLanguage="en" />} />
      <Route path="/download-app" element={<Download defaultLanguage="ar" />} />
      <Route path="/download-app/ar" element={<Download defaultLanguage="ar" />} />
      <Route path="/download-app/en" element={<Download defaultLanguage="en" />} />
      <Route path="/app" element={<Download defaultLanguage="ar" />} />
      <Route path="/app/ar" element={<Download defaultLanguage="ar" />} />
      <Route path="/app/en" element={<Download defaultLanguage="en" />} />
      <Route path="*" element={<MainLayout />} />
    </Routes>
  );
};

export default App;
